import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TermsEn from "./terms-en";
import TermsAr from "./terms-ar";

const Terms = () => {
  const { t } = useTranslation();

  return (
    <main>
      <Container>
        <Row>
          <Col lg="12">{t("language") === "en" ? <TermsAr /> : <TermsEn />}</Col>
        </Row>
      </Container>
    </main>
  );
};

export default Terms;
